import { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { useLang } from '../../i18n';
import { Img } from '../Img';
import { altOf } from '../../lib/seasonMedia';

/**
 * Tre colonne da tablet in su, con la sola colonna centrale scesa di un passo:
 * ancora un menabò, ma una pausa e non un capitolo. Su telefono due colonne
 * pari: sei foto a meta' larghezza invece di due a tutta pagina.
 */
const POSTI = ['', 'md:mt-16', '', '', 'md:mt-16', ''];
/** Ogni foto scorre a una velocita' sua: segno opposto = profondita'. */
const VELOCITA = [0.6, -0.4, 0.3, -0.6, 0.5, -0.3];

const rapporto = (r) => {
  const [a, b] = r.split('/').map(Number);
  return a / b;
};

const Foto = ({ item, i, progress, ridotto, lang }) => {
  const v = ridotto ? 0 : VELOCITA[i % VELOCITA.length] * 60;
  const y = useTransform(progress, [0, 1], [v, -v]);
  return (
    <motion.figure style={{ y }} className={POSTI[i % POSTI.length]}>
      <div className="overflow-hidden bg-carta" style={{ aspectRatio: item.ratio.replace('/', ' / ') }}>
        <Img
          src={item.src}
          alt={altOf(item, lang)}
          width={1200}
          aspectRatio={rapporto(item.ratio)}
          sizes="(min-width: 768px) 30vw, 50vw"
          className="img-zoom h-full w-full object-cover"
        />
      </div>
    </motion.figure>
  );
};

/**
 * Le feste da vicino: sei scatti reali dell'archivio, sfalsati, con un
 * parallax leggero (nullo con reduced motion).
 */
export const SeasonGallery = ({ items }) => {
  const { t, lang } = useLang();
  const ridotto = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'], layoutEffect: false });

  if (!items?.length) return null;
  return (
    <section ref={ref} data-testid="season-gallery" className="overflow-hidden bg-carta-2 py-14 md:py-20">
      <div className="wrap">
        <h2 className="max-w-[20ch] text-[clamp(2rem,5.6vw,3.8rem)] leading-[1.04]">{t('season.galleryTitle')}</h2>
        <p className="prosa mt-4 max-w-[44ch]">{t('season.galleryLead')}</p>
        <div className="mt-12 grid grid-cols-2 items-start gap-4 md:mt-14 md:grid-cols-3 md:gap-6">
          {items.map((item, i) => (
            <Foto key={item.src} item={item} i={i} progress={scrollYProgress} ridotto={ridotto} lang={lang} />
          ))}
        </div>
      </div>
    </section>
  );
};
